"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginRequest = void 0;
var LoginRequest = /** @class */ (function () {
    function LoginRequest() {
    }
    return LoginRequest;
}());
exports.LoginRequest = LoginRequest;
//# sourceMappingURL=login.request.js.map